import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import {
    Container,
    Segment,
    Header,
    Message,
    List,
    Progress,
    Grid
} from 'semantic-ui-react'

class NoMoreThanYes extends Component {

    constructor(props) {
        super(props)

    }

    unixTime(unixtime) {

        return moment
            .unix(unixtime)
            .tz(moment.tz.guess())
            .format('DD/MM/YYYY HH:mm')
    }

    render() {

        let { recipient, amount, description, voteYes, voteNo, allVotes, minimumVotes, isDeadlineOver, deadline, proposalId} = this.props

        return(
            <Segment style={{  minHeight: 700, paddingTop: '1em', paddingBottom: '4em' }} vertical>
                <Container>
                    <Header as='h1' style={{fontSize: '3em', fontWeight: 'normal',marginBottom: '1.5em',marginTop: '2em'}}>
                        {proposalId}. {description} {recipient === 'No recipient' ? '' : 'Recipient: '+recipient}
                    </Header>
                    <Grid stackable verticalAlign='middle' style={{paddingBottom: '2.5em'}}>
                        <Grid.Row>
                            <Grid.Column width={6}>
                                <List size='huge' relaxed style={{fontWeight: 'normal', padding:'1em', color: 'rgba(0,0,0,.68)'}}>
                                    {recipient === 'No recipient' ? '' : <List.Item icon='payment' content={amount} />}
                                    <List.Item icon='users' content={'Min '+minimumVotes+' voters'} />
                                    <List.Item icon='time' content={'Until '+this.unixTime(deadline)} />
                                </List>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Progress size='large' value={voteYes} total={allVotes} color='green' progress='ratio' disabled={isDeadlineOver} active={!isDeadlineOver}/>
                                <Progress size='large' value={voteNo} total={allVotes} color='red' progress='ratio' disabled={isDeadlineOver} active={!isDeadlineOver}/>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column floated='right' width={6}>
                                <Message icon='exclamation triangle' compact error content='Proposal can not be executed.'/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>				
                </Container>
            </Segment>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        recipient: state.proposal.data.recipient,
        amount: state.proposal.data.amount,
        description: state.proposal.data.description,
        voteYes: state.proposal.data.voteYes,
        voteNo: state.proposal.data.voteNo,
        allVotes: state.proposal.data.allVotes,
        minimumVotes: state.proposal.data.minimumVotes,
        deadline: state.proposal.data.deadline,
        proposalId: state.proposal.data.proposalId,
        isDeadlineOver: state.proposal.data.isDeadlineOver
    }
}

export default connect(mapStateToProps)(NoMoreThanYes)

NoMoreThanYes.propTypes = {
 
    recipient:PropTypes.string,
    amount: PropTypes.string,
    description: PropTypes.string,
    voteYes:PropTypes.string,
    voteNo:PropTypes.string,
    allVotes:PropTypes.string,
    minimumVotes:PropTypes.string,
    isDeadlineOver:PropTypes.bool,
    deadline:PropTypes.string,
    proposalId:PropTypes.string

}


// WEBPACK FOOTER //
// ./src/layouts/proposal/components/NoMoreThanYes.js